module.exports = __webpack_public_path__ + "static/media/Pic-0184.7dafc120.jpg";